<template>
  <div><loading-spinner /></div>
</template>
<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import { langFallback$Fetch } from '../../../lang/utils/langfetch'

@Component
class MakeAnotherBookingPage extends Vue {
  async mounted() {
    const { lang, pretty_id } = this.$route.params
    const response: { url: string } = await langFallback$Fetch(
      lang,

      `/booking/make_another_booking/${pretty_id}/?json=1`,
    )
    await useRouter().replace(response.url)
  }
}

export default toNative(MakeAnotherBookingPage)
</script>
